import Vue from 'vue'
import Vuex from 'vuex'
import account from './modules/account'
import setting from './modules/setting'
import business from './modules/business'
import findpassword from './modules/findpassword'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    account,
    setting,
    business,
    findpassword
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js